module.exports = __webpack_public_path__ + "img/kexue1.d46189c0.png";